import React from "react";
// Ensure CSS is imported in your main App or here
import "../App.css"; 

const HowToUse = () => {
  return (
    <div style={{ paddingTop: "6rem", background: "white" }}>
      {/* Header */}
      <div style={{ textAlign: "center", padding: "4rem 1rem" }}>
        <span className="hero-badge">The Process</span>
        <h1 className="hero-title" style={{ fontSize: "3.5rem" }}>
          From Chaos to <span className="highlight">Clarity</span>
        </h1>
        <p className="hero-description" style={{ marginBottom: "0" }}>
          Using MoonshotMap is simple. You get clarity in minutes, not weeks.
        </p>
      </div>

      {/* Timeline Steps */}
      <div className="how-to-container">
        
        {/* Step 1 */}
        <div className="step-row right">
          <div className="step-number">1</div>
          <div className="step-content">
            <h3 className="step-title">Define Your Moonshot</h3>
            <p className="step-desc">
              Tell the AI your goal, idea, or direction — in your own words.
              MoonshotMap analyzes it, reduces ambiguity, and creates your first structured draft.
            </p>
          </div>
        </div>

        {/* Step 2 */}
        <div className="step-row left">
          <div className="step-number">2</div>
          <div className="step-content">
            <h3 className="step-title">Break It Into a Roadmap</h3>
            <p className="step-desc">
              MoonshotMap automatically generates phases, milestones, assumptions, and dependencies.
              You can edit, refine, or expand each step based on your vision.
            </p>
          </div>
        </div>

        {/* Step 3 - Contains List */}
        <div className="step-row right">
          <div className="step-number">3</div>
          <div className="step-content">
            <h3 className="step-title">Understand Your Scores</h3>
            <p className="step-desc">
              You get three proprietary clarity signals to help you see strengths and gaps instantly.
            </p>
            <ul className="step-list">
              <li>
                <span className="step-badge">Clarity Score™</span>
                <span>How well defined your strategy is.</span>
              </li>
              <li>
                <span className="step-badge">Fog Index™</span>
                <span>What feels vague, risky, or incomplete.</span>
              </li>
              <li>
                <span className="step-badge">Reality Check™</span>
                <span>How grounded your plan is in market data.</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Step 4 */}
        <div className="step-row left">
          <div className="step-number">4</div>
          <div className="step-content">
            <h3 className="step-title">Track Progress & Adapt</h3>
            <p className="step-desc">
              As you move forward, MoonshotMap updates your roadmap based on your inputs and external signals — 
              including industry news, market shifts, and funding patterns.
            </p>
          </div>
        </div>

        {/* Step 5 */}
        <div className="step-row right">
          <div className="step-number">5</div>
          <div className="step-content">
            <h3 className="step-title">Share or Export Your Map</h3>
            <p className="step-desc">
              Generate a founder report, investor update, or team-ready roadmap in one click. 
              MoonshotMap gives you clarity, structure, and direction - anytime you need it.
            </p>
          </div>
        </div>

      </div>

      {/* Bottom CTA */}
      <div style={{ textAlign: "center", padding: "6rem 2rem", background: "var(--bg-secondary)" }}>
        <h2 style={{ fontSize: "2.5rem", fontWeight: "700", marginBottom: "2rem" }}>Ready to map your future?</h2>
        <button className="cta-primary">Start Mapping Free</button>
      </div>
    </div>
  );
};

export default HowToUse;